import * as THREE from 'three';
import { Object3D } from "./Viewer.Object3D.js";

class Hinge extends Object3D {
    constructor(xLoc = 0, material) {
        super();

        this.material = material;

        const sphereGeometry = new THREE.SphereGeometry( 0.5 , 12, 12);
        const sphere = new THREE.Mesh( sphereGeometry, this.material );

        this.add( sphere );

        this.xLoc = xLoc;

        this.setScale( 0.1 );
    }

    setScale( scaleFactor ) {
        this.scale.set( scaleFactor, scaleFactor, scaleFactor );

        if (this.xLoc === 0) {
            this.position.set(this.xLoc + 0.5 * scaleFactor, 0, 0);
        } else {
            this.position.set(this.xLoc - 0.5 * scaleFactor, 0, 0);
        }
    }

    setColor( color ) {
        this.material.color.set( color );
    }
}

export { Hinge };